<script>
export default {
  props: {
    formatNames: {
      type: String,
      default: null,
    },
    image: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
  },
  methods: {
    uploadImage(image) {
      this.$emit('uploadImageTo', image)
    },
    onDrop: function(e) {
      e.stopPropagation()
      e.preventDefault()
      this.$emit('onDrop', e)
    },
    onChange(e) {
      this.$emit('onChange', e)
    },
    removeFile(image) {
      this.$emit('removeImageTo', image)
    },
  },
}
</script>

<template>
  <div>
    <div :class="$style.imagewrapper" class="p-3">
      <div class="file-upload-form" @dragover.prevent @drop="onDrop">
        <label :class="$style.lblImgLender" for="imgLender">
          <div v-if="!image">
            <b-img
              src="@assets/images/default_img.png"
              :class="$style.noImage"
              center
              class="py-3 my-auto"
            />
          </div>
          <img
            else
            :src="image"
            alt
            :class="$style.preview"
            :disabled="isDisabled"
          />

          <input
            id="imgLender"
            :type="type"
            name="image"
            class="d-none"
            accept=".jpeg, .jpg, .png"
            :disabled="isDisabled"
            @change="onChange"
          />
        </label>
      </div>
      <p class="text-center" style="margin-top: -35px;">
        Drop image here or
        <label :class="$style.fileContainer" @change="onChange">
          Browse
          <input
            :type="type"
            class="d-none"
            :disabled="isDisabled"
            accept=".jpeg, .jpg, .png"
          />
        </label>
      </p>
      <p :class="$style.conditions"
        >[Max Size: 1 MB, Width × Height: 180 × 60px]</p
      >
      <p :class="$style.conditions">[File Type: PNG, JPEG, JPG]</p>

      <div class="float-right mr-3 d-flex">
        <BaseEButton
          v-if="image"
          id="btnRemove"
          variant="cancel"
          class="btn btn-sm mr-2"
          type="button"
          @click="removeFile"
          >REMOVE</BaseEButton
        >
        <BaseEButton
          id="btnUpload"
          class="btn btn-sm"
          type="button"
          :disabled="isDisabled"
          @click="uploadImage(image)"
          >UPLOAD</BaseEButton
        >
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.fileContainer {
  color: $color-link-text;
  cursor: pointer;
}
.removeBtn {
  font-weight: $heading-font-weight !important;
  color: $color-button-bg !important;
  text-shadow: 0;
  background-color: $color-button-text !important;
  border: 1px solid $color-button-bg;
  box-shadow: 0;
}
.noImage {
  width: 26%;
}
.removeBtn:hover,
.upload:hover {
  color: $color-text-white !important;
  background-color: #5a6268 !important;
  border-color: #545b62 !important;
}
.cancelBtn:hover {
  color: $color-text-white !important;
  background-color: #5a6268 !important;
}
.imagewrapper {
  height: 291px;
  background: #ececec;
}
.lblImgLender {
  width: 60%;
  height: 102px;
  min-height: 102px;
  margin: 5% 20% 10%;
  cursor: pointer;
  border: 1px dashed #999;
  object-fit: contain;
}
.conditions {
  margin-top: -20px;
  font-size: 12px;
  color: grey;
  text-align: center;
}
.preview {
  position: absolute;
  top: 24%;
  left: 33%;
  width: 180px;
  min-width: 180px;
  height: 60px;
  max-height: 60px;
  transform: translateY(-50%);
}
input[type='file'] {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
</style>
